import { ThemeIcon, type ThemeIconProps } from "@mantine/core";
import clsx from "clsx";

interface AppThemeIconProps extends ThemeIconProps {}

const AppThemeIcon = ({
  children,
  className,
  variant = "transparent",
  ...rest
}: AppThemeIconProps) => {
  return (
    <ThemeIcon
      className={clsx("size-3 min-h-0 min-w-0", className)}
      variant={variant}
      {...rest}
    >
      {children}
    </ThemeIcon>
  );
};

export default AppThemeIcon;
